import React from 'react';
import ReactTable from 'react-table';
import { currencyFormater, displayDateFormater, mustBeArray } from '../../utils/lib';
import _ from 'lodash-es';
import { Input } from 'reactstrap';
import { BASE_URL, READY_FOR_EXPORT_STATUS_ID } from '../../constants';
import TooltipTitle from '../Common/TooltipTitle';

const RebatesRCTIList = props => {
    const {handleAllSelected, handleCheckboxSelection, allSelected, handleExport, handleRCTIView, exportingRebates,
                    selectedRows, rebatesList} = props;
    const getRCTIListColumns =  () => {return([
        {
            id: 'selected',
            accessor: x => x.selected,
            Header: <div className="flex justify-content-center pl-1 selectableRowCheckbox">
                    <Input type="checkbox"
                        onChange={(e)=> handleAllSelected(e.target.checked)}
                        checked={allSelected}
                        disabled={_.isEmpty(mustBeArray(rebatesList))}
                    />
                </div>,
            maxWidth: 60,
            sortable: false,
            Cell: row => (<div className="flex justify-content-center pl-1 selectableRowCheckbox">
                        <Input type="checkbox"
                                onChange={()=> handleCheckboxSelection(row.original)}
                                checked={(mustBeArray(selectedRows).includes(row.original.id)) && (row.original.exportStatusID == READY_FOR_EXPORT_STATUS_ID)}
                                disabled={row.original.exportStatusID !== READY_FOR_EXPORT_STATUS_ID}
                            />
                </div>)
        },
        {
            id: 'id',
            Header: 'RCTI No',
            accessor: x => x.rctiNumber,
            maxWidth: 100,
            Cell: row => (<div className="text-primary hand" onClick={e => handleRCTIView(row.original)}>
                            {row && row.value}
                        </div>)   
        },
        {
            id: 'rctiDate',
            Header: 'RCTI Date',
            accessor: x => x.rctiDate,
            maxWidth: 130, 
            Cell: row => (<div >{displayDateFormater({value: row && row.value})}</div>)                                
        },
        {
            id: 'clientName',
            Header: 'Client Name',
            accessor: x => x.clientName,
            maxWidth: 250,                              
        },
        {
            id: 'amount',
            Header: 'Total Rebate Amount',
            accessor: x => x.totalRebateAmount, 
            Cell: row => (<div className="text-right pr-q">{currencyFormater(row && row.value)}</div>)                             
        },
        {
            id: 'exportStatus',
            Header: 'Export Status',
            accessor: x => x.exportStatusName,  
            Cell: (row) => (<div className="pl-h">{
                ((row && row.value) === "Error" ?
                    <TooltipTitle 
                        text={row.value}
                        tooltipTitle={row.original && row.original.exportErrorMessage}
                        id={row.original && row.original.rctiNumber}
                        titleClassName="hand"
                    />
                    :
                    row && row.value
                )
                }</div>)                              
        },
        {
            id: 'actions',
            Header: '',
            sortable: false,
            Cell: row => row.original.exportStatusID === READY_FOR_EXPORT_STATUS_ID ? 
                <div className="text-center">
                    <button className={`btn btn-success btn-sm bold ${mustBeArray(exportingRebates).includes(row.original && row.original.id) 
                        ? "no-pointer-events" : ""}`} onClick={() => handleExport({data: row.original})}>
                        <i className={"fa fa-arrow-up"} /> &nbsp;{mustBeArray(exportingRebates).includes(row.original && row.original.id) 
                        ? "Exporting" : "Export"}
                    </button>
                </div>
                : <React.Fragment />,
            maxWidth: 110,
        }
    ])};
    return(
        <ReactTable
            sortable
            filterable={false}
            showPagination={true}
            data={rebatesList}
            defaultPageSize={20}
            columns={getRCTIListColumns()}
            minRows={mustBeArray(rebatesList).length === 0 ? 5 : mustBeArray(rebatesList).length > 20 ? 20 : mustBeArray(rebatesList).length}
            className="selectableRowTable"
            defaultSorted={[
                {
                  id: "rctiDate",
                  desc: true
                }
              ]}
        />
    );
};
export default RebatesRCTIList;